import React, {useCallback} from "react";
import SimpleDataTable from "./SimpleDataTable";
import NoResultsFound from "./NoResultFound";

const DataTableLayout = React.memo(({
                                        //   loading=false,
                                        //   LoaderLayout=null,
                                        showNoResultsMsg = false,
                                        noResultsMsgLabel = "No data found!",
                                        // ...rest
                                        ...rest
                                    }) => {
    const {data, columns} = rest
    // if (loading) return LoaderLayout ? LoaderLayout : ''
    return (
        <div>
            {
                data?.length > 0
                    ?
                    (
                        <SimpleDataTable {...rest} />
                    )
                    :
                    (
                        showNoResultsMsg
                        &&
                        // <NoResultsFound
                        //     size='1.8rem'
                        //     className={`datatable__no-results`}
                        //     msg={noResultsMsgLabel}
                        // />
                        <>
                            <SimpleDataTable {...rest} />
                            <h4 style={{textAlign:"center",border:"1px solid #ddd"}} className="text-jost-sb-22">{noResultsMsgLabel}</h4>

                        </>
                    )
            }
        </div>
    )


})

export default DataTableLayout;
